
import {initWebComponent} from "@/helpers/web-component-helper";
import {resetMap} from "@/helpers/ol/ol-map-helper";
import {hideHeaderElement} from "@/helpers/header-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button 
    data-icon="fa fa-book" 
    data-tooltip="openLayerMenu">
</header-button>`;

export class HeaderLayerComponent extends HTMLElement {
    constructor() {
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            hideHeaderElement('layer-menu')
        });
    }
}

